import moment										from 'moment';

import {AllContract}								from '../../redux/contracts/interface';
import {InputValues}								from '../components/Input/interface';
import {ContractStatus}								from '../language/type';


export function ft_getContractStatus(contract: AllContract, indexFunder?: number, cancelCheckNeedAction?: boolean): keyof ContractStatus {
	let finalStatus: keyof ContractStatus = 'locationEnd';

	if (!contract)
		return 'sign';

	const isValala = 'funderList' in contract;

	if (!isValala)
		return 'notValala';

	if (indexFunder === undefined) {
		contract.funderList.forEach((funder) => {
			if (!funder.dateEnd)
				finalStatus = 'sign';
		});
	} else if (!contract.funderList[indexFunder].dateEnd)
		finalStatus = 'sign';

	if (!cancelCheckNeedAction && finalStatus !== 'locationEnd' && ft_isContractNeedAction(contract, indexFunder))
		finalStatus = 'needAction';

	return finalStatus;
}

export function ft_getContractLocationEnd(contract: AllContract, indexFunder?: number): InputValues {
	if (!contract)
		return '';

	const isValala = 'funderList' in contract;

	if (!isValala)
		return contract.locationEnd ? moment(contract.locationEnd).format('DD/MM/YYYY') : '';

	if (!indexFunder || !contract.funderList[indexFunder])
		indexFunder = 0;

	if (contract.funderList[indexFunder]?.locationEnd)
		return moment(contract.funderList[indexFunder].locationEnd).format('DD/MM/YYYY');

	if (contract.funderList[indexFunder]?.locationStart && contract.funderList[indexFunder].duration)
		return moment(contract.funderList[indexFunder].locationStart).add(contract.funderList[indexFunder].duration, 'months').format('DD/MM/YYYY');

	return '';
}

export function ft_isContractNeedAction(contract: AllContract, indexFunder?: number): boolean {
	if (!contract || !('funderList' in contract) || ft_getContractStatus(contract, indexFunder, true) === 'locationEnd')
		return false;

	const endDate = ft_getContractLocationEnd(contract, indexFunder);

	return !!endDate && moment(endDate, 'DD/MM/YYYY').isBefore(moment().add(1, 'month'));
}